import React from 'react';
import lang from '../../lang/lang.json';
import ErrorTriangle from '../icon/ErrorTriangle';
import { useSelector } from 'react-redux';
import './errorwarning.scss';

const ErrorWarnin = () => {
  const { language } = useSelector((state) => state.language);

  return (
    <div className="error-container">
      <div className="error-icon">
        <ErrorTriangle />
      </div>
      <div className="error-text-div">{lang.SUBMIT_USER_WARNING[language]}</div>
    </div>
  );
};

export default ErrorWarnin;
